<template>
  <div>
<!--    This is to compensate the menu temp.-->
    <br>
    <br>



    <table class="table-bordered tasks_table">
      <tr>
        <td colspan="2" class="search_shop">
          Sales Person
          <select class="" @change="changeSalesperson($event)" v-model="selected_dropdown_list_value">
            <option v-for="sales_person in sales_tasks_details.sales_person_list" :value="sales_person.usertoken"  :key="sales_person.usertokend">{{ sales_person.name }}</option>
          </select>
          Date
          <select class="" @change="changeDate($event)" v-model="selected_date">
            <option v-for="dates in sales_tasks_details.dates_list" :value="dates.value"  :key="dates.value">{{ dates.display }}</option>
          </select>
        </td>
      </tr>
    </table>


    <template v-if="person_day_is_set">

      <h4>Duties</h4>
      <table class="table-bordered align_left tasks_table">
        <thead>
        <tr>
        </tr>
        </thead>
        <tbody class="align_left duty_background">
          <tr v-for="notes in sales_tasks_details.duty_list_array" v-bind:key="notes.id">
            <td class="duty_notes">
              <input
                  type="text"
                  id="notes"
                  v-model="notes.task_todo_text"
                  placeholder=""
                  name="notes"
                  class="input_field"
                  @input="notes.task_todo_text = $event.target.value"
                  @blur="update_duty_note(notes.task_todo_text,notes.id)"
              />
            </td>

            <td class="delete_duty_td">
              <button @click="delete_duty_note(notes.id)" class="delete_duty_button">Delete</button>
            </td>

          </tr>

          <tr v-for="notes_others in sales_tasks_details.duty_list_other_salesperson_array" v-bind:key="notes_others.id">
            <td class="input_field" colspan="2">
              {{notes_others.formatted_text}}
            </td>
            <td>

            </td>

          </tr>

        <tr>
          <td colspan="2"  class="add_duty_td">
            <button @click="add_new_duty_note()" class="add_duty_button">Add New Line</button>
          </td>
        </tr>

        </tbody>
      </table>


      <h4>Feedback</h4>


<!--      Start search new shop -->

      <table class="table-bordered align_left tasks_table">
        <tr>
          <td colspan="2" class="search_shop">
            Search Shop
            <input
                type="text"
                id="customer_search_string"
                class="find_shop_input"
                :value="customer_search_string"
                @keyup="shop_search_state = 0"
                @input="customer_search_string = $event.target.value"
            >
            <button @click="getCustomerListSelection(customer_search_string)" v-if="shop_search_state === 0" class="find_shop_button">Find Shops to Add</button>
            <template v-if="shop_search_state > 1" >
              <select id="recipients_address" @change="set_selected_shop($event.target.value)" v-model="selected_shop">
                <option v-for="(shop,index) in leaflink_customers_copy.shops"
                        :value="shop.customer_id"
                        v-bind:key="index"
                        v-bind:selected="index === 0"
                >{{shop.companyname}} - {{shop.customer_id}}
                </option>
              </select>
            </template>

            <template v-if="customer_search_string === ''">
              <input
                  type="text"
                  id="add_custom_shop"
                  class="add_custom_shop"
                  :value="add_custom_shop_string"
                  @keyup="add_custom_shop_state = 0"
                  @input="add_custom_shop_string = $event.target.value"
              >
              <button @click="addCustomShop()" class="add_shop_button">Add NEW shop</button>
            </template>

          </td>
        </tr>
      </table>

<!--      End search new shop-->


      <table class="table-bordered align_left tasks_table">
        <thead>
        <tr>
          <th class="th_header">Shop</th>
          <th class="th_header notes_background">Notes</th>
          <th class="th_header todo_background">Todo Text</th>
          <th class="th_header todo_background">Person</th>
          <th class="th_header todo_background">Date</th>
        </tr>
        </thead>
        <tbody class="align_left">


<!--        <template v-for="(task_customer_id, day_index) in sales_tasks_details.day_array">-->
          <template v-for="(task_customer_id) in sales_tasks_details.day_array">

<!--          <tr v-for="(tasks, task_index) in task_customer_id" v-bind:key="tasks.id">-->
            <tr v-for="(tasks) in task_customer_id" v-bind:key="tasks.id">

            <template v-if="tasks.rowspan > 0">
              <td :rowspan="tasks.rowspan" class="td_dispensary">
                {{tasks.customer_company_name}} - {{tasks.customer_id}}
                <div class="last_edit_time">{{tasks.last_edit_shop_hrmin}}</div>

                <div class="center_button">
                  <template v-if="tasks.delete_shop_allowed === 1">
                    <button @click="remove_shop(tasks.customer_id)" class="remove_shop_button">Remove This Shop</button>
                  </template>
                  <template v-else>
                    <button @click="add_new_task(tasks.customer_id)" class="add_shop_line_button">Add New Line</button>
                  </template>
                </div>

              </td>
            </template>

<!--            @keyup="check_notes_input(tasks.id, day_index, task_index)"-->
<!--              todo: example on how to locally update data array-->

<!--         https://github.com/88labs/vue-textarea-autosize/blob/master/README.md-->

              <td class="notes_background">
                  <textarea-autosize
                      type="text"
                      id="notes"
                      v-model="tasks.notes"
                      placeholder=""
                      name="notes"
                      class="input_field"
                      onkeyup="setHeight.call(this)"
                      oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'
                      @input="tasks.notes = $event.target.value"
                      @blur.native="set_data_field('notes',tasks.notes,tasks.id,tasks.task_hash)"
                  />
              </td>
              <td class="todo_background">
                  <textarea-autosize
                      type="text"
                      id="todo_text"
                      v-model="tasks.todo_text"
                      placeholder=""
                      name="todo_text"
                      class="input_field"
                      @input="tasks.todo_text = $event.target.value"
                      @blur.native="set_data_field('todo_text',tasks.todo_text,tasks.id,tasks.task_hash)"
                  />
              </td>


            <td class="todo_person_date_dropdown todo_background">
              <div class="">
                <select class="" @change="changeSalespersonTodo($event,tasks.id,tasks.task_hash)" v-model="tasks.todo_sales_person_usertoken">
                  <option v-for="sales_person_todo in sales_tasks_details.sales_person_list" :value="sales_person_todo.usertoken" :key="sales_person_todo.usertoken">{{ sales_person_todo.name }}</option>
                </select>
              </div>
            </td>

            <td class="todo_person_date_dropdown todo_background">
              <div class="">
                <select class="" @change="changeDateTodo($event,tasks.id,tasks.task_hash)" v-model="tasks.todo_date">
                  <option v-for="dates in sales_tasks_details.dates_list_todo" :value="dates.value" :key="dates.value">{{ dates.display }}</option>
                </select>
              </div>
            </td>

          </tr>





        </template>



        </tbody>
      </table>


      <button @click="send_duty_email()">Send Duty List email TEST</button>


    </template>

    <br>
    <br>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
        show_task_form: 0,
        form_status: 0,
        selected_dropdown_list_value: '',
        selected_date: '',
        customer_search_string: '',
        add_custom_shop_string: '',
        selected_shop: '',
        leaflink_customers_copy: [],
        view_type: 1,
        selected_todo_date_test: '',
        shop_search_state: 0,
        add_custom_shop_state: 0,
      taskid : -1,
    }
  },
  computed: {
    ...mapGetters({
      sales_tasks_details: 'admin/sales_tasks_details',
      sent_duty_email_response: 'admin/sent_duty_email_response',
      leaflink_customers_selected: 'admin/leaflink_customers_selected',
    }),
    person_day_is_set() {
      if(this.selected_dropdown_list_value && this.selected_date) {
        return 1;
      } else {
        return 0;
      }
    },
  },
  watch: {
    sales_tasks_details: async function () {
      this.selected_dropdown_list_value = this.sales_tasks_details.selected_user_token;
      this.selected_date = this.sales_tasks_details.selected_date;
    },
    leaflink_customers_selected: async function () {
      if(this.shop_search_state === 1) {
        this.shop_search_state = 2;
      }
      this.leaflink_customers_copy = this.leaflink_customers_selected;
    },
  },
  mounted() {
    this.leaflink_customers_copy = [];
    this.$store.dispatch('admin/getTaskDetail',
        {
          'task_date': '',
          'sales_person_hash': '',
          'action_type': 'just_data',
          'field': '',
          'value': ''
        });
  },
  methods: {
    check_notes_input(task_id, day_index, task_index) {
      this.sales_tasks_details.day_array[day_index][task_index].notes.length;
      // this.sales_tasks_details.day_array[day_index][task_index].textarea_type = 1;
    },
    set_selected_shop() {
      // If we need button to confirm, then activate it and disable this code
      this.add_new_customer_to_tasks(this.selected_shop);
    },
    add_new_customer_to_tasks(customer_id) {
      this.leaflink_customers_copy = [];
      this.shop_search_state = 0;
      this.customer_search_string = '';
      this.selected_shop = '';
      if(this.person_day_is_set) {
        this.$store.dispatch('admin/getTaskDetail',
          {
            'task_date': this.selected_date,
            'sales_person_hash': this.selected_dropdown_list_value,
            'action_type': 'create_new_note',
            'field': 'customer_id',
            'value': customer_id,
          });
      }
    },
    add_new_task(customer_id) {
      this.leaflink_customers_copy = [];
      this.customer_search_string = '';
      this.selected_shop = '';
      if(this.person_day_is_set) {

        this.$store.dispatch('admin/getTaskDetail',
            {
              'task_date': this.selected_date,
              'sales_person_hash': this.selected_dropdown_list_value,
              'action_type': 'create_new_note',
              'field': 'customer_id',
              'value': customer_id,
            });
      }
    },
    remove_shop(customer_id) {
      this.leaflink_customers_copy = [];
      this.customer_search_string = '';
      this.selected_shop = '';
      if(this.person_day_is_set) {

        this.$store.dispatch('admin/getTaskDetail',
            {
              'task_date': this.selected_date,
              'sales_person_hash': this.selected_dropdown_list_value,
              'action_type': 'remove_shop',
              'field': 'customer_id',
              'value': customer_id,
            });
      }
    },
    getCustomerListSelection(searchstring) {
      this.leaflink_customers_copy = [];
      this.shop_search_state = 1;
      this.$store.dispatch('admin/getCustomerListResults', {'searchstring' : searchstring});
    },
    addCustomShop() {
      if(this.person_day_is_set) {
        this.customer_search_string = this.add_custom_shop_string;
        this.$store.dispatch('admin/getTaskDetail',
            {
              'task_date': this.selected_date,
              'sales_person_hash': this.selected_dropdown_list_value,
              'action_type': 'add_custom_shop',
              'field': '',
              'value': this.add_custom_shop_string,
            });
        this.add_custom_shop_string = '';
      }
    },
    changeSalesperson(event) {
      this.selected_dropdown_list_value = event.target.options[event.target.options.selectedIndex].value;
      if(this.person_day_is_set) {
        this.$store.dispatch('admin/getTaskDetail',
            {
              'task_date': this.selected_date,
              'sales_person_hash': this.selected_dropdown_list_value,
              'action_type': 'just_data',
              'field': '',
              'value': ''
            });
      }
    },
    changeDate(event) {
      this.selected_date= event.target.options[event.target.options.selectedIndex].value;
      if(this.person_day_is_set) {
        this.$store.dispatch('admin/getTaskDetail',
            {
              'task_date': this.selected_date,
              'sales_person_hash' : this.selected_dropdown_list_value,
              'action_type' : 'just_data',
              'field': '',
              'value': ''
            });
      }
    },
    changeDateTodo(event,task_id,task_hash) {
      var selected_date = event.target.options[event.target.options.selectedIndex].value;

      if(this.person_day_is_set) {
        this.$store.dispatch('admin/getTaskDetail',
          {
            'task_date': this.selected_date,
            'sales_person_hash' : this.selected_dropdown_list_value,
            'action_type': 'update_field',
            'task_id': task_id,
            'task_hash': task_hash,
            'field': 'todo_date',
            'value': selected_date,
          });
      }
    },
    changeSalespersonTodo(event,task_id,task_hash) {
      var todo_sales_person_usertoken = event.target.options[event.target.options.selectedIndex].value;

      if(this.person_day_is_set) {
        this.$store.dispatch('admin/getTaskDetail',
            {
              'task_date': this.selected_date,
              'sales_person_hash' : this.selected_dropdown_list_value,
              'action_type': 'update_field',
              'task_id': task_id,
              'task_hash': task_hash,
              'field': 'todo_sales_person_usertoken',
              'value': todo_sales_person_usertoken,
            });
      }
    },
    set_data_field(field,value,taskid,task_hash) {
      this.$store.dispatch('admin/getTaskDetail',
          {
            'task_date': this.selected_date,
            'sales_person_hash': this.selected_dropdown_list_value,
            'action_type': 'update_field',
            'task_id': taskid,
            'task_hash': task_hash,
            'field': field,
            'value': value,
          });
    },
    add_new_duty_note() {
      if(this.person_day_is_set) {
        this.$store.dispatch('admin/getTaskDetail',
            {
              'task_date': this.selected_date,
              'sales_person_hash': this.selected_dropdown_list_value,
              'action_type': 'create_new_duty_note',
              'field': '',
              'value': '',
              'task_id': '',
              'task_hash': '',
            });
      }
    },
    update_duty_note(value,duty_id) {
      if(this.person_day_is_set) {
        this.$store.dispatch('admin/getTaskDetail',
            {
              'task_date': this.selected_date,
              'sales_person_hash': this.selected_dropdown_list_value,
              'action_type': 'update_duty_note',
              'field': 'task_todo_text',
              'value': value,
              'task_id': duty_id,
              'task_hash': '',
            });
      }
    },
    delete_duty_note(duty_id) {
      if(this.person_day_is_set) {
        this.$store.dispatch('admin/getTaskDetail',
            {
              'task_date': this.selected_date,
              'sales_person_hash': this.selected_dropdown_list_value,
              'action_type': 'delete_duty_note',
              'field': '',
              'value': '',
              'task_id': duty_id,
              'task_hash': '',
            });
      }
    },
    send_duty_email() {
      if(this.person_day_is_set) {
        this.$store.dispatch('admin/sendDutyListEmail',
            {
              'task_date': this.selected_date,
              'sales_person_hash': this.selected_dropdown_list_value,
              // 'sales_person_hash': this.selected_dropdown_list_value
            });
      }
    },
  }
}
</script>

<style scoped>


.delete_duty_td{


}


.last_edit_time {
  vertical-align: middle;
  text-align: center;
  padding: 1px;
  font-size: smaller;
}

.center_button {
  vertical-align: middle;
  text-align: center;
}

.delete_duty_button {
  margin: 7px;
  font-size: 16px;
  color: black;
  background-color: lightcoral;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
}

.add_duty_button {
  margin: 7px;
  font-size: 16px;
  color: black;
  background-color: lightgreen;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
}

.add_duty_td {
  vertical-align: middle;
  text-align: center;
}

.find_shop_button {
  margin: 7px;
  font-size: 16px;
  color: black;
  background-color: lightskyblue;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
}

.add_shop_button {
  margin: 7px;
  font-size: 16px;
  color: black;
  background-color: dodgerblue;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
}



.add_shop_line_button {
  font-size: 16px;
  color: black;
  background-color: lightgreen;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
}

.remove_shop_button {
  font-size: 16px;
  color: black;
  background-color: lightcoral;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
}

.align_left {
  text-align: left;
}

.duty_background {
  background-color: #ffe0e0;
}

.notes_background {
  background-color: #f0f0ff;
}

.todo_background {
  background-color: #f0fff0;
}

.th_header {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 7px;
}

.td_dispensary {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 7px;

  font-weight: 700;
  width: 240px;
}
.search_table_mobile {
  margin: 10px;
  width:calc(100% - 22px);
}

.tasks_table {
  margin: 10px;
  width:calc(100% - 22px);
}

.input_field {
  width:calc(100% - 15px);
  padding-left: 7px;
  margin: 7px;
}

.todo_person_date_dropdown {
  width: 50px;
}

.duty_notes {
  width: 100%;
}


.search_shop {
  vertical-align: middle;
  text-align: center;
  padding: 7px;
}


.find_shop_input {
  margin:7px;
  width: 126px;
}


</style>
